import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { useIsAdmin } from './useUserRole';

export function useCanAccessAudit() {
  const { profile } = useAuth();
  const { isAdmin, isLoading: adminLoading } = useIsAdmin();

  const { data: isPolicyOwner, isLoading: ownerLoading } = useQuery({
    queryKey: ['is-policy-owner', profile?.id],
    queryFn: async () => {
      if (!profile) return false;

      const { data, error } = await supabase
        .from('policies')
        .select('id')
        .eq('policy_owner', profile.id)
        .limit(1);

      if (error) throw error;
      return (data?.length ?? 0) > 0;
    },
    enabled: !!profile && !isAdmin,
  });

  const isLoading = adminLoading || ownerLoading;
  const canAccess = isAdmin || isPolicyOwner === true;

  return { canAccess, isLoading };
}
